import { Modal } from "antd";
import { MemberForm } from "./MemberForm";

/**
 * Reusable Modal for Adding a Member
 */
export const AddMemberModal = ({
  visible,
  member,
  onOk,
  onCancel,
  onChange,
  translate = (key) => key,
}) => {
  return (
    <Modal
      title={translate("organizations.addMember")}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <MemberForm
        member={member}
        onChange={onChange}
        translate={translate}
        isEditing={false}
      />
    </Modal>
  );
};

/**
 * Reusable Modal for Editing Member Roles
 */
export const EditMemberModal = ({
  visible,
  member,
  onOk,
  onCancel,
  onChange,
  translate = (key) => key,
}) => {
  return (
    <Modal
      title={translate("organizations.editMemberRoles")}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <MemberForm
        member={member}
        onChange={onChange}
        translate={translate}
        isEditing={true}
      />
    </Modal>
  );
};
